import { useMemo } from "react";

import { useUserStore } from "@faire/retailer/stores/domain/UserStore";
import { NotificationIconType } from "@faire/retailer/views/settings/useMenuItems";

import { useInsiderState } from "../insider/useInsiderState";
import { useInsiderTermsAndConditionsConsentStatus } from "../insider/useInsiderTermsAndConditionsConsentStatus";

export const useInsiderNotificationType = () => {
  const { userCanPlaceOrder: userCanAcceptTerms } = useUserStore([
    "userCanPlaceOrder",
  ]);
  const { isInsiderActive, isInsiderPaused, isInsiderUnpaid } =
    useInsiderState();

  const { isInsiderTermsAndConditionsPendingOrOutdated } =
    useInsiderTermsAndConditionsConsentStatus();

  return useMemo(() => {
    if (!(isInsiderActive || isInsiderPaused || userCanAcceptTerms)) {
      return;
    }

    if (isInsiderUnpaid) {
      return NotificationIconType.CRITICAL;
    }

    if (isInsiderTermsAndConditionsPendingOrOutdated) {
      return NotificationIconType.NOTIFICATION;
    }

    return;
  }, [
    isInsiderActive,
    isInsiderPaused,
    isInsiderTermsAndConditionsPendingOrOutdated,
    isInsiderUnpaid,
    userCanAcceptTerms,
  ]);
};
